
(function () {
    'use strict';

    angular
        .module('invesfleet')
        .filter('dateFormat', dateFormatFilter);

    function dateFormatFilter($filter) {
        /*jshint maxcomplexity:false */
        return function (ISOstring) {

            var MONTHS = ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio',
                'Agosto','Septiembre','Octubre','Noviembre','Diciembre'];

            if(ISOstring === null){ return ''; }
            var date = new Date(ISOstring);

            var today = Date.NewDate();


            if(today.getFullYear() === date.getFullYear() && 
            today.getMonth() === date.getMonth() && 
            today.getDate() === date.getDate()){
                //Its today
                return $filter('date')(date, 'HH:mm');
            } else {
                var day = $filter('date')(date, 'dd');
                var month = MONTHS[date.getMonth()].substring(0, 3);
                return day + ' ' + month + '.';
            }
        };
    }

})();